module.exports = __webpack_public_path__ + "static/media/hdsd-otp-guide.62e7cbc6.jpg";